module.exports = __webpack_public_path__ + "img/certik1.d27fd01c.png";